import { Maybe, MaybeUndef } from 'types/UtilityTypes';

export const getThreeGHostFromTenant = (
  tenant: MaybeUndef<string>
): Maybe<string> => {
  const normalizedTenant = tenant?.trim();
  if (!normalizedTenant) {
    return null;
  }

  const tenantWithProtocol = /^https?:\/\//i.test(normalizedTenant)
    ? normalizedTenant
    : `https://${normalizedTenant}`;

  try {
    const parsedTenant = new URL(tenantWithProtocol);
    const hostname = parsedTenant.hostname.trim();

    if (!hostname) {
      return null;
    }

    const hostWithDomain = hostname.includes('.')
      ? hostname
      : `${hostname}.3gtms.com`;

    return parsedTenant.port
      ? `${hostWithDomain}:${parsedTenant.port}`
      : hostWithDomain;
  } catch {
    return null;
  }
};

export const buildThreeGWebUrl = (
  tenant: MaybeUndef<string>,
  path: string
): Maybe<string> => {
  const threeGHost = getThreeGHostFromTenant(tenant);
  if (!threeGHost) {
    return null;
  }

  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `https://${threeGHost}${normalizedPath}`;
};

export const getThreeGOrderURLInTMS = (
  orderInternalId: string,
  tenant: MaybeUndef<string>
): Maybe<string> => {
  if (!orderInternalId) {
    return null;
  }

  return buildThreeGWebUrl(tenant, `/web/viewOrder/${orderInternalId}`);
};
